<section class="flex h-full flex-col gap-3">
  <section class="border border-neutral-20 px-4 py-4">
    <div
      class="-mt-4 -mx-4 mb-3 border-b border-warning-40 bg-authorized-5 px-3 py-3 text-sm text-warning-160 [&_a]:font-semibold [&_a]:text-info"
      [innerHTML]="'outlookSync.infoBanner' | translate"
    ></div>
    <label for="outlook-email-sync-toggle" class="flex items-center gap-3">
      <span
        class="inline-flex"
        kendoTooltip
        position="top"
        [title]="
          'outlookSync.email.syncDirectionTooltip' | translate
        "
      >
        <kendo-switch
          id="outlook-email-sync-toggle"
          [formControl]="form().controls.emailsSyncEnabled"
        ></kendo-switch>
      </span>
      <span class="font-semibold text-component-text">
        {{ 'outlookSync.email.toggleDescription' | translate }}
      </span>
    </label>
    <p class="mt-2 text-sm text-component-text">
      <strong>{{
        'outlookSync.syncDirection.label' | translate
      }}</strong>
      {{ 'outlookSync.email.syncDirection' | translate }}
    </p>

    <p class="mt-3 text-sm font-semibold text-component-text">
      {{ 'outlookSync.email.scope' | translate }}
    </p>
    <p
      class="mt-1 text-sm text-component-text [&_a]:font-semibold [&_a]:text-info"
      [innerHTML]="'outlookSync.email.learnMore' | translate"
    ></p>

    <div class="mt-2 flex flex-col gap-1.5">
      <label
        class="flex cursor-pointer items-center gap-2 text-sm"
        [class.opacity-60]="emailSubscriptionModeDisabled"
      >
        <input
          id="outlook-email-subscription-mode-auto"
          type="radio"
          name="email-subscription-mode"
          kendoRadioButton
          [checked]="form().controls.emailsSyncSyncEverything.value"
          [disabled]="emailSubscriptionModeDisabled"
          (change)="selectEmailSubscriptionMode('auto')"
        />
        <span class="text-component-text">
          {{
            'outlookSync.email.subscriptionMode.auto.label'
              | translate
          }}
        </span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-2 text-sm"
        [class.opacity-60]="emailSubscriptionModeDisabled"
      >
        <input
          id="outlook-email-subscription-mode-manual"
          type="radio"
          name="email-subscription-mode"
          kendoRadioButton
          [checked]="!form().controls.emailsSyncSyncEverything.value"
          [disabled]="emailSubscriptionModeDisabled"
          (change)="selectEmailSubscriptionMode('manual')"
        />
        <span class="text-component-text">
          {{
            'outlookSync.email.subscriptionMode.manual.label'
              | translate
          }}
        </span>
      </label>
    </div>

    <p class="mt-3 flex items-center gap-2 text-sm text-neutral-70">
      <span class="fa-icons icon-10 icon-circle-info" aria-hidden="true"></span>
      {{
        'outlookSync.email.note'
          | translate: { minutes: syncFrequency.intervalMinutes }
      }}
    </p>
    <p class="mt-2 flex items-center gap-2 text-sm text-neutral-70">
      <span class="fa-icons icon-10 icon-circle-info" aria-hidden="true"></span>
      {{ 'outlookSync.email.autoSaveListNote' | translate }}
    </p>
  </section>

  <maximizer-history-grid
    [history]="history()"
    [loading]="historyLoading()"
    inSyncColumnTitleKey="outlookSync.history.columns.savedEmails"
    [boxed]="false"
    (refresh)="refreshHistory()"
  ></maximizer-history-grid>

  @if (!form().controls.emailsSyncSyncEverything.value) {
    <section class="mt-3">
      <header class="flex items-center justify-between gap-3">
        <h3 class="m-0 inline-flex items-center gap-1.5 text-base">
          {{ 'outlookSync.subscriptions.title' | translate }}
          <span
            class="fa-icons icon-10 icon-circle-question"
            aria-hidden="true"
          ></span>
        </h3>
        <span
          class="text-xs tabular-nums text-component-text/55"
          kendoTooltip
          position="top"
          [title]="
            'outlookSync.subscriptions.usageTooltip'
              | translate
                : {
                    count: totalEmailSubscriptions(),
                    limit: emailSubscriptionLimit,
                  }
          "
        >
          {{
            'outlookSync.subscriptions.usage'
              | translate
                : {
                    count: totalEmailSubscriptions(),
                    limit: emailSubscriptionLimit,
                  }
          }}
        </span>
      </header>
      <kendo-grid
        [data]="emailGridData()"
        [loading]="emailLoading()"
        [pageSize]="emailPageSize()"
        [skip]="emailSkip()"
        [pageable]="emailPager"
        (pageChange)="onEmailPageChange($event)"
        class="email-grid mt-2"
      >
        <kendo-grid-column
          field="contactName"
          [title]="
            'outlookSync.subscriptions.columns.name' | translate
          "
        ></kendo-grid-column>
        <kendo-grid-column
          field="companyName"
          [title]="
            'outlookSync.subscriptions.columns.company' | translate
          "
        ></kendo-grid-column>
        <kendo-grid-column
          [title]="
            'outlookSync.subscriptions.columns.email' | translate
          "
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            @for (email of dataItem.emailAddresses; track email) {
              <span class="mr-2 inline-flex text-[0.85rem]">
                {{ email }}
              </span>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="createdAt"
          [title]="
            'outlookSync.subscriptions.columns.added' | translate
          "
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.createdAt | date: 'short' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          [title]="
            'outlookSync.subscriptions.columns.action' | translate
          "
          [width]="90"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <button
              kendoButton
              fillMode="flat"
              type="button"
              class="!min-w-0 !px-1"
              (click)="removeSubscription(dataItem.maximizerKey)"
              title="{{
                'outlookSync.subscriptions.remove' | translate
              }}"
              aria-label="{{
                'outlookSync.subscriptions.remove' | translate
              }}"
            >
              <span
                class="fa-icons icon-14 icon-trash-can"
                aria-hidden="true"
              ></span>
            </button>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoGridNoRecordsTemplate>
          <div class="p-4 text-center text-component-text/55">
            {{ 'outlookSync.subscriptions.empty' | translate }}
          </div>
        </ng-template>

        <ng-template kendoGridToolbarTemplate position="bottom">
          <div class="flex w-full items-center justify-end">
            <button
              kendoButton
              fillMode="flat"
              type="button"
              class="!min-w-0 !px-1 text-neutral-70"
              [disabled]="emailLoading()"
              (click)="refreshEmailSubscriptions()"
              aria-label="{{ 'outlookSync.history.refresh' | translate }}"
            >
              <span class="fa-icons icon-14 icon-rotate-right"></span>
            </button>
          </div>
        </ng-template>
      </kendo-grid>
    </section>
  }

  @if (form().controls.emailsSyncSyncEverything.value) {
    <section class="mt-3">
      <header class="flex items-center justify-between gap-3">
        <h3 class="m-0 inline-flex items-center gap-1.5 text-base">
          <span>
            {{ 'outlookSync.exclusions.titleStart' | translate }}
            <strong class="text-error">
              {{ 'outlookSync.exclusions.titleEmphasis' | translate }}
            </strong>
            {{ 'outlookSync.exclusions.titleEnd' | translate }}
          </span>
          <span
            class="fa-icons icon-10 icon-circle-question"
            aria-hidden="true"
          ></span>
        </h3>
      </header>
      <kendo-grid
        [data]="exclusionGridData()"
        [loading]="exclusionLoading()"
        [pageSize]="exclusionPageSize()"
        [skip]="exclusionSkip()"
        [pageable]="exclusionPager"
        (pageChange)="onExclusionPageChange($event)"
        class="email-grid mt-2"
      >
        <kendo-grid-column
          field="contactName"
          [title]="
            'outlookSync.exclusions.columns.name' | translate
          "
        ></kendo-grid-column>
        <kendo-grid-column
          field="companyName"
          [title]="
            'outlookSync.exclusions.columns.company' | translate
          "
        ></kendo-grid-column>
        <kendo-grid-column
          [title]="
            'outlookSync.exclusions.columns.email' | translate
          "
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            @for (email of dataItem.emailAddresses; track email) {
              <span class="mr-2 inline-flex text-[0.85rem]">
                {{ email }}
              </span>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="createdAt"
          [title]="
            'outlookSync.exclusions.columns.added' | translate
          "
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.createdAt | date: 'short' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          [title]="
            'outlookSync.exclusions.columns.action' | translate
          "
          [width]="90"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <button
              kendoButton
              fillMode="flat"
              type="button"
              class="!min-w-0 !px-1"
              (click)="requestRemoveExclusion(dataItem)"
              title="{{
                'outlookSync.exclusions.remove' | translate
              }}"
              aria-label="{{
                'outlookSync.exclusions.remove' | translate
              }}"
            >
              <span
                class="fa-icons icon-14 icon-trash-can"
                aria-hidden="true"
              ></span>
            </button>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoGridNoRecordsTemplate>
          <div class="p-4 text-center text-component-text/55">
            {{ 'outlookSync.exclusions.empty' | translate }}
          </div>
        </ng-template>

        <ng-template kendoGridToolbarTemplate position="bottom">
          <div class="flex w-full items-center justify-end">
            <button
              kendoButton
              fillMode="flat"
              type="button"
              class="!min-w-0 !px-1 text-neutral-70"
              [disabled]="exclusionLoading()"
              (click)="refreshExclusions()"
              aria-label="{{ 'outlookSync.history.refresh' | translate }}"
            >
              <span class="fa-icons icon-14 icon-rotate-right"></span>
            </button>
          </div>
        </ng-template>
      </kendo-grid>
    </section>
  }
</section>
